
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/creator/interview-kuu-chan",
      function () {
        return require("private-next-pages/about/creator/interview-kuu-chan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/creator/interview-kuu-chan"])
      });
    }
  